const DEFAULT_ERROR_DELAYER = async (delay: number): Promise<void> =>
  new Promise((resolve): void => {
    setTimeout(resolve, delay);
  });

export async function retry<T>(
  name: string,
  cb: () => Promise<T>,
  maxTries = 20,
  delayBase = 1_000,
  onErrorDelayer = DEFAULT_ERROR_DELAYER,
): Promise<T> {
  for (let tries = 0; tries < maxTries; tries++) {
    try {
      return await cb();
    } catch {
      await onErrorDelayer(delayBase * (tries + 1) + Math.random() * delayBase);
    }
  }
  throw new Error(`Failed to setup ${name} after ${maxTries} tries`);
}

export async function decompressToParseJson<T>(data: Uint8Array, parser: (x: unknown) => T): Promise<T> {
  const ds = new DecompressionStream("deflate");
  const writer = ds.writable.getWriter();
  // Do not await on write/close, Promise never resolves in browsers
  writer.write(new Uint8Array(data));
  writer.close();

  const decompressed = await new Response(ds.readable).arrayBuffer();
  const decoder = new TextDecoder();
  const stringRaw = decoder.decode(decompressed);
  return parser(JSON.parse(stringRaw));
}
